// Reusable skeleton block. Pass `w`, `h`, and optional `r` (radius).
export default function Skeleton({ w = "100%", h = 16, r = 12, style }) {
  return (
    <div
      className="skeleton"
      style={{
        width: typeof w === "number" ? `${w}px` : w,
        height: typeof h === "number" ? `${h}px` : h,
        borderRadius: r,
        ...style,
      }}
    />
  );
}
